import { useEffect, useState } from 'react';
import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useTranslation } from 'react-i18next';

const ServiceImage = ({ option, disabled, onTitleChange, onRemove }) => {
  const { t } = useTranslation('common');
  const [previewUrl, setPreviewUrl] = useState('');
  const { file, stockImported, stockTitle = '' } = option;
  const imageUrl = option.url || file?.previewUrl;

  useEffect(() => {
    if (imageUrl || !file) return;
    const objectUrl = URL.createObjectURL(file);
    setPreviewUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file, imageUrl]);

  const fileName = file?.name || option.value;
  const displayName = stockImported ? stockTitle : fileName;
  const extension = fileName.split('.').pop();
  const uploadLabel = `${fileName.substring(0, fileName.length >= 13 ? 4 : 9)}${fileName.length >= 13 ? '...' : ''}.${extension}`;

  return (
    <Box sx={{ width: '110px', minWidth: 0 }}>
      <img
        src={imageUrl || previewUrl}
        alt={displayName}
        style={{
          width: '100px',
          height: '100px',
          objectFit: 'cover',
          borderRadius: '8px'
        }}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', minHeight: '56px' }}>
        <Tooltip title={displayName}>
          {stockImported ? (
            <input
              aria-label={t('title')}
              value={stockTitle}
              onChange={(event) =>
                onTitleChange(option.value, event.target.value)
              }
              disabled={disabled}
              maxLength={500}
              style={{
                width: '100%',
                minWidth: 0,
                border: 0,
                background: 'transparent',
                color: '#666',
                fontSize: '12px',
                padding: 0,
                textOverflow: 'ellipsis'
              }}
            />
          ) : (
            <Button
              component='a'
              href={imageUrl || previewUrl}
              download={fileName}
              disabled={disabled}
              sx={{ minWidth: 0, textTransform: 'none' }}
            >
              <Typography variant='body2' sx={{ fontSize: '12px' }}>
                {uploadLabel}
              </Typography>
            </Button>
          )}
        </Tooltip>
        <IconButton
          aria-label={t('delete')}
          disabled={disabled}
          onClick={() => onRemove(option)}
          size='small'
        >
          <DeleteOutlineIcon fontSize='small' />
        </IconButton>
      </Box>
    </Box>
  );
};

const ServiceImageList = ({ options, disabled, onTitleChange, onRemove }) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
    {options.map((option) => (
      <ServiceImage
        key={option.value}
        option={option}
        disabled={disabled}
        onTitleChange={onTitleChange}
        onRemove={onRemove}
      />
    ))}
  </Box>
);

export default ServiceImageList;
